import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const API = axios.create({ baseURL: BASE });

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const login = (username, password) =>
    API.post("/auth/login", { username, password });

export const verifyToken = () => API.get("/auth/verify");

export const listFiles = (parentId) =>
    API.get("/files", { params: { parentId } });

export const getBreadcrumb = (id) => API.get(`/files/path/${id}`);

export const getFileInfo = (id) =>
    API.get(`/files/${id}/info`);

export const createFolder = (name, parentId) =>
    API.post("/files/folder", { name, parentId });

export const uploadFile = (file, parentId, onProgress) => {
    const formData = new FormData();
    formData.append("file", file);
    if (parentId) formData.append("parentId", parentId);
    return API.post("/files/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
            if (onProgress) onProgress(Math.round((e.loaded * 100) / e.total));
        },
    });
};

export const renameItem = (id, name) =>
    API.patch(`/files/${id}/rename`, { name });

export const moveItem = (id, targetParentId) =>
    API.patch(`/files/${id}/move`, { targetParentId });

export const deleteItem = (id) => API.delete(`/files/${id}`);

export const createShareLink = (id) => API.post(`/files/${id}/share`);

export const revokeShareLink = (id) => API.delete(`/files/${id}/share`);

export const getDownloadUrl = (id) => `${BASE}/files/${id}/download`;

export const getShareUrl = (token) =>
    `${window.location.origin}/share/${token}`;

export const createBundle = (name, fileIds, folderIds = []) =>
    API.post("/bundles", { name, fileIds, folderIds });

export const listBundles = () => API.get("/bundles");

export const renameBundle = (id, name) => API.patch(`/bundles/${id}`, { name });

export const toggleBundle = (id) => API.patch(`/bundles/${id}/toggle`);

export const deleteBundle = (id) => API.delete(`/bundles/${id}`);

export const getBundleUrl = (token) =>
    `${window.location.origin}/bundle/${token}`;

export const getBundleInfo = (token) =>
    fetch(`${BASE}/bundles/share/${token}`).then((res) =>
        res.ok ? res.json() : Promise.reject(res),
    );

export const getBundleFileUrl = (token, fileId) =>
    `${BASE}/bundles/share/${token}/file/${fileId}`;

export default API;
